import React, {useEffect, useState} from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { useHistory, useLocation } from 'react-router-dom';
import {verifyemail} from "../apis"
import { toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import './verifyemail.css'

const Verifyemail = (props) => {
  const history = useHistory();

  const [user_id, setUser_id] = useState("");
  const [code, setCode] = useState(""); 

  const handleChange = (e) => {
    setCode(e.target.value.trim());
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if(!code){
      return toast.error("Enter code");
    }
    verifyemail(JSON.stringify({user_id, code}))
  };


  useEffect(() => {
    const queryParams = new URLSearchParams(props.location.search);
    const user_id = queryParams.get('user_id');
    if(!user_id){
      history.push('/login');
    }
    setUser_id(user_id);
  }, []);
  

  return (
    <div className="verifyemail-container">
      <Helmet>
        <title>verifyemail - wapi</title>
        <meta property="og:title" content="verifyemail - wapi" />
      </Helmet>
      <div className="verifyemail-container1">
        <h2 className="verifyemail-text">WAPI</h2>
        <Link to="/signup" className="verifyemail-navlink button">
          Signup
        </Link>
      </div>
      <div className="verifyemail-container2">
        <div className="verifyemail-container3">
          <div className="verifyemail-container4">
            <h3>Verifyemail</h3>
          </div>
          <input
            type="text"
            required
            placeholder="enter code"
            minlength="4"
            maxlength="4"
            value={code}
            className="verifyemail-textinput input"
            onChange={handleChange}
          />
          <div className="verifyemail-container5">
            <span className="verifyemail-text2">
              Click here to resend email
            </span>
          </div>
          <button className="verifyemail-button button" onClick={handleSubmit}>Verify</button>
        </div>
      </div>
    </div>
  )
}

export default Verifyemail
